module.exports = __webpack_public_path__ + "static/media/K-open.169c6268.svg";